import { CharField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Persona } from "../../types"

export default function PersonaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Persona>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <CharField
        label="Anno di nascita"
        layout="horizontal"
        value={values.anno_nascita}
        onChange={(value) => {
          setFieldValue("anno_nascita", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "anno_nascita") : undefined}
        errorMessage={getIn(errors, "anno_nascita")}
      />
      <CharField
        label="Anno di morte"
        layout="horizontal"
        value={values.anno_morte}
        onChange={(value) => {
          setFieldValue("anno_morte", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "anno_morte") : undefined}
        errorMessage={getIn(errors, "anno_morte")}
      />
    </Col>
  )
}
